import React, {Component} from 'react';
import axios from 'axios';
import {Label,Menu, Message, Form } from 'semantic-ui-react';
import {Divider,Progress, Input, Step, Header,Modal,Dimmer, Loader, Grid, Segment, Item, Image, Popup, Button, Icon, Card} from 'semantic-ui-react';
import Panel from '../../components/Panel';
import { Link } from 'react-router-dom'

class Redeem extends Component {
  constructor() {
    super(...arguments);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      code: '',
      codeError: false,
      msg: '',
      user:this.props.main,
      msgType:'',
      loading: false,
    };
    window.scrollTo(0, 0);
  }

  handleSubmit() {
    let {code} = this.state;
    code = code.trim();
    const regex = /^[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}$/;
    if (!code || !regex.test(code)) {
      this.setState({
        msg: 'Code Error',
        msgType: 'error',
        codeError: true,
      });
      return;
    }
    this.setState({loading: true});
    axios.post('/user/code', {code,force:false}).then((res) => {
      this.setState({code: '', codeError: false, loading: false});
      const {code, message, data} = res.data;
      if (code !== 0) {
        this.setState({
          msg: message || 'Redeem Error',
          msgType: 'error',
        });
      } else {
        const {balance, change} = data;
        if (balance > 0 && change > 0) {
          this.setState({
            msg: `成功兑换 ${change} 天`,
            msgType: 'success',
          });
        } else {
          this.setState({
            msg: '出现错误，请联系客服',
            msgType: 'error'
          });
        }
      }
    }).catch((err) => {
      this.setState({
        msg: '请求失败，请刷新页面重试，或联系客服',
        msgType: 'error',
        loading: false,
      });
    });
  }

  handleChange(e, {name, value}) {
    this.setState({
      [name]: value,
      codeError: false,
      msg: '',
      msgType: '',
    });
  }

  render(){
    return (
      <React.Fragment>
        <Segment>
        <Header
          as='h2'
          style={{marginTop:"2px"}}
          content='Giftcards'
          subheader='Redeem Plan'
        />

      <p>Step 1: purchase codes below</p>
        <Grid textAlign='center' columns={2}>
    <Grid.Row>
      <Grid.Column>
        <Menu fluid vertical>
          <Menu.Item className='header'>Basic</Menu.Item>
          <Menu.Item><a href="https://37apps.net/shop/2002">100 Days</a></Menu.Item>
          <Menu.Item><a href="https://37apps.net/shop/2003">200 Days</a></Menu.Item>
          <Menu.Item><a href="https://37apps.net/shop/2004">400 Days</a></Menu.Item>
        </Menu>
      </Grid.Column>
      <Grid.Column>
        <Menu fluid vertical>
          <Menu.Item className='header'>Pro</Menu.Item>
          <Menu.Item><a href="https://37apps.net/shop/2012">100 Days</a></Menu.Item>
          <Menu.Item><a href="https://37apps.net/shop/2013">200 Days</a></Menu.Item>
          <Menu.Item><a href="https://37apps.net/shop/2014">400 Days</a></Menu.Item>
        </Menu>
      </Grid.Column>
    </Grid.Row>
  </Grid>
      <br/>
      <p>Step 2: enter your code</p>
      <Segment secondary style={{background:"#ccc"}}>
        <Form onSubmit={this.handleSubmit} autocomplete="off" error={this.state.msgType === 'error'} success={this.state.msgType === 'success'}>
          <Form.Field style={{marginTop:"20px"}}>
            <Form.Input error={this.state.codeError} placeholder='XXXXX-XXXXX-XXXXX-XXXXX' name='code' value={this.state.code} onChange={this.handleChange} />
          </Form.Field>
          <Form.Field>
            <Form.Button large primary loading={this.state.loading}>Enter</Form.Button>
          </Form.Field>
          {
            this.state.msg
              ?
              <Message error={this.state.msgType === 'error'} success={this.state.msgType === 'success'}>
                {this.state.msg}
              </Message>
              :
              null
          }
        </Form>
      </Segment>
      <br/>
      <br/>
      <br/>
      <br/>
      </Segment>
    </React.Fragment>
    )
  }
}


export default Redeem;
